// utils/transformProductMarkets.js
export function TransformProductMarkets(productMarkets) {
  if (!Array.isArray(productMarkets)) return [];

  return productMarkets.map(({ market, id }) => ({
    option: market,
    value: id
  }));
}